import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bank-list"
export default class extends Controller {
  static targets = ["list", "text", "icon"];

  connect() {
    console.log("Bank list controller connected successfully!");
  }

  toggle() {
    console.log("Toggle method called!");

    if (this.listTarget.classList.contains("hidden")) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    console.log("Showing bank list");
    this.listTarget.classList.remove("hidden");
    this.listTarget.classList.add("animate-fade-in");

    if (this.hasTextTarget) {
      this.textTarget.textContent = "Hide Bank Details";
    }

    this.updateIcon(true);
  }

  hide() {
    console.log("Hiding bank list");
    this.listTarget.classList.add("hidden");
    this.listTarget.classList.remove("animate-fade-in");

    if (this.hasTextTarget) {
      this.textTarget.textContent = "View Bank Details for Deposit";
    }

    this.updateIcon(false);
  }

  updateIcon(isExpanded) {
    if (this.hasIconTarget) {
      const rotation = isExpanded ? "rotate(180deg)" : "rotate(0deg)";
      this.iconTarget.style.transform = rotation;
      console.log(`Icon rotated: ${rotation}`);
    }
  }
}
